import { InputBase } from './input-base';
/**
 * TextboxInput Component.
 */
export class TextboxInput extends InputBase<string>{
    controlType = 'textbox';
}